import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import construction from "@/assets/industry-construction.jpg";
import maintenance from "@/assets/industry-maintenance.jpg";
import plants from "@/assets/industry-plants.jpg";
import hero from "@/assets/hero-industrial.jpg";
import { useLanguage } from "@/contexts/LanguageContext";
import { SectionHeading } from "@/components/ui/section-heading";

const About = () => {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const t = {
    eyebrow: isAr ? "من نحن" : "About Us",
    h1: isAr ? "حول العربية الواحة" : "About Arabian",
    h2: isAr ? "للتجارة والمقاولات" : "Al Waha Est.",
    p1: isAr
      ? "مؤسسة العربية الواحة مزوّد خدمات سعودي متخصص في توريد العمالة والمعدات ودعم المواد للمشاريع الصناعية والإنشائية."
      : "Arabian Al Waha Est. is a Saudi-based service provider specializing in manpower supply, equipment, and material support for industrial and construction projects.",
    p2: isAr
      ? "نركز على تقديم حلول موثوقة وسريعة الاستجابة لتلبية متطلبات الإيقافات والصيانة وعمليات المشاريع الجارية."
      : "We focus on delivering reliable and fast-response solutions to meet the demands of shutdowns, maintenance, and ongoing project operations.",
    p3: isAr
      ? "فريقنا ملتزم بدعم العملاء بعمالة ماهرة وانتشار مرن في الجبيل وينبع والدمام، وبناء شراكات طويلة الأمد من خلال خدمة موثوقة وتعبئة سريعة ودعم مستمر."
      : "Our team is committed to supporting clients with skilled workforce and flexible deployment across Jubail, Yanbu, and Dammam — building long-term partnerships through dependable service, quick mobilization, and consistent support.",
    cta: isAr ? "لماذا تختارنا" : "Why Choose Us",
  };
  return (
    <section className="py-20 bg-background" id="about">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="block w-10 h-px bg-heading" />
              <span className="heading-eyebrow">{t.eyebrow}</span>
            </div>
            <SectionHeading
              accent={t.h2}
              wrapperClassName="mb-6"
            >
              {t.h1}
            </SectionHeading>
            <p className="text-base lg:text-lg text-muted-foreground leading-relaxed mb-4">
              {t.p1}
            </p>
            <p className="text-base lg:text-lg text-muted-foreground leading-relaxed mb-4">
              {t.p2}
            </p>
            <p className="text-base lg:text-lg text-muted-foreground leading-relaxed mb-8">
              {t.p3}
            </p>
            <Button
              size="lg"
              className="bg-primary-darker hover:bg-primary-dark text-primary-foreground font-bold uppercase tracking-wide"
              onClick={() => document.getElementById('why-us')?.scrollIntoView({ behavior: 'smooth' })}
            >
              {t.cta} <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>

          {/* Image collage */}
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-2 rounded-xl overflow-hidden aspect-[4/3]">
              <img src={construction} alt="Construction site" loading="lazy" width={1024} height={768} className="w-full h-full object-cover" />
            </div>
            <div className="flex flex-col gap-3">
              <div className="rounded-xl overflow-hidden aspect-square">
                <img src={maintenance} alt="Welding maintenance" loading="lazy" width={512} height={512} className="w-full h-full object-cover" />
              </div>
              <div className="rounded-xl overflow-hidden aspect-square">
                <img src={plants} alt="Industrial plants" loading="lazy" width={512} height={512} className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="col-span-3 rounded-xl overflow-hidden aspect-[16/6]">
              <img src={hero} alt="Oil & gas operations" loading="lazy" width={1920} height={720} className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;